// This is Initial Data for AreaType 1 [2^1 Combinations = 2]
export const initialState: any = [
  { Id: -1, Area1Status: 2, Area2Status: null, Area3Status: null, Area4Status: null, FolderId: -1, ImageId: -1, FolderName: "", ImageName: "", Comment: "", Width: 500, Height: 500 },
  { Id: -1, Area1Status: 0, Area2Status: null, Area3Status: null, Area4Status: null, FolderId: -1, ImageId: -1, FolderName: "", ImageName: "", Comment: "", Width: 500, Height: 500 },
];
